import { BaseLayoutFactory } from "../global/base-layout-factory";
import { PublicAccountProvider } from "./context/public-account-context";
import { PublicAccountComponent } from "./public-account-component";
;


export function PublicAccountFactory() {
    return (
        <BaseLayoutFactory>
            <PublicAccountProvider>
                <PublicAccountComponent />
            </PublicAccountProvider>
        </BaseLayoutFactory>
    );
}